import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { MindOrderCreateRequest, MindOrderCreateResponse } from '../models/mind-order.model';
import { environment } from '../../../environments/environment';

import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class MindService {
  private readonly baseUrl = `${environment.externalGateServiceUrl}/mind`;
  private apiService = inject(ApiService);


  createOrder(payload: MindOrderCreateRequest): Observable<MindOrderCreateResponse> {
    return this.apiService.postExternal<MindOrderCreateResponse>(`${this.baseUrl}/order/create`, payload);
  }
}
